/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".fuel[_ngcontent-%COMP%]{text-align:center}.fuel__price[_ngcontent-%COMP%]{font-size:0;color:#85bd33}.fuel__price-symbol[_ngcontent-%COMP%]{position:relative;top:-5px;font-size:12px;font-weight:700}.fuel__price-value[_ngcontent-%COMP%]{font-size:20px;font-weight:700}.fuel__type[_ngcontent-%COMP%]{font-size:11px;font-weight:500}"];
export { styles as styles };
